import { handleActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const defaultState = {
  departmentsV1List: [],
  hrList: [],
  publishStateList: [],
  jdCreateList: [],
  filterStatusList: [],
  jobList: [],
  userList: [],
  interviewSignStatusList: {},
  interviewTypeList: {},
  interviewWayList: {},
  stageALLTypeMap: [],
  channelNameList: [],
  channelTypeList: [],
  weedoutFailTypeList: [],
  weedoutChannelTypeList: [],
  postStatusList: [],
  needDepartList: [],
};

// 将后端返回的map形式（ "code": xx, "desc": "xxx" }）转化为{value: xx,text: 'xxx'}
const resetMapType = (list) => {
  const mapList = [];
  for (const map of list.values()) {
    const newMap = {
      value: map.code,
      text: map.desc,
    };
    mapList.push(newMap);
  }
  return mapList;
};
// 将对象变为{value: key, test: data[key]}的数组
const objToJoin = (data) => {
  const list = [];

  for (const key of Object.keys(data)) {//eslint-disable-line
    list.push({
      value: key,
      text: data[key],
    });
  }
  return list;
}

const getJobList = (data) => {
  const list = [];
  data.forEach((r) => {
    list.push({
      text: `${r.jobName}[${r.jdNo}]`,
      value: r.jdId,
      jobTitle: r.jobName,
      jdNo: r.jdNo,
    });
  });
  return list;
}

const getUserList = (result) => {
  const list = [];
  result.forEach((r) => {
    const id = r.ldap ? `${r.ldap}，` : '';
    const userId = r.ldap || '';
    const infos = r.deptName === '未知' ? r.emailAddr : r.deptName;
    const msg = id && infos ? `（${id}${infos}）` : '';
    list.push({
      text: `${r.name}${msg}`,
      value: r.empId,
      name: r.name,
      id: userId,
    });
  });
  return list;
}

// 职位状态
function getPostStatusList(res, all = false) {
  const reqData = res.data || {};
  let list = reqData.jdPublishStatus || [];

  if (! all) {
    list = list.filter((st) => {
      if (+ st.code === 2) {
        return st;
      }
      return null;
    });
  }
  list = resetMapType(list);
  return list;
}

//需求部门
const getNeedDepartList = (data) => {
  const list = [];
  data.forEach((r) => {
    list.push({
      ndTitle: r,
    });
  });
  return list;
}

const statisticsReducer = handleActions({
  // 一级部门列表
  [actionTypes.DEPARTMENT_LIST_GET_REQUEST_SUCCESS]: (state, res) => ({...state, departmentsV1List: res.payload.data}),
  // HR
  [actionTypes.HR_LIST_GET_REQUEST_SUCCESS]: (state, res) => ({...state, hrList: res.payload.data}),
  // 当前状态: 待发布/招聘中/已取消
  [actionTypes.PUBLISH_STATE_LIST_GET_REQUEST_SUCCESS]: (state, action) =>
    ({...state, publishStateList: resetMapType(action.payload.data.jdPublishStatus)}),
  // 需求提交人 hr-data/jobstaff
  [actionTypes.JD_CREATE_STATE_LIST_GET_REQUEST_SUCCESS]: (state, res) => ({...state, jdCreateList: res.payload.data}),
  // 流程状态 审批中/审批完成/已驳回/已撤销
  [actionTypes.JD_PUBLISH_STATUS_LIST_GET_REQUEST_SUCCESS]:
    (state, res) => ({...state, jdPublishStateList: resetMapType(res.payload.data)}),
  // 筛选状态: 筛选通过/筛选未通过
  [actionTypes.FILTER_STATUS_LIST_GET_REQUEST_SUCCESS]:
    (state, action) => ({...state, filterStatusList: objToJoin(action.payload.data)}),
  // 职位名称 ALL_POSITION_API
  [actionTypes.JOB_LIST_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state, jobList: getJobList(action.payload.data)}),
  //人才库职位名称 TALENT_POSITION_API
  [actionTypes.TALENT_JOB_LIST_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state, jobList: getJobList(action.payload.data)}),
  // 获取面试官 同HR一个接口，处理数据方式不同：姓名 (ldap,部门)
  [actionTypes.USER_LIST_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state, userList: getUserList(action.payload.data)
    }),
  // 获取面试形式/面试类型/签到状态
  [actionTypes.INTERVIEW_TYPE_WAY_SIGNSTATUS_LIST_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state,
      interviewSignStatusList: action.payload.data.InterviewSignStatusEnum,
      interviewTypeList: action.payload.data.InterviewTypeEnum,
      interviewWayList: action.payload.data.InterviewWayEnum,
    }),
  // 获取应聘者数据分析map 阶段-状态/申请渠道类型/申请渠道名称
  [actionTypes.APPLICANT_MAP_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state,
      stageALLTypeMap: action.payload.data.phaseType,
      channelNameList: action.payload.data.channeName,
      channelTypeList: action.payload.data.channelType,
    }),
  // 淘汰类型
  [actionTypes.WEEDOUT_MAP_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state,
      weedoutFailTypeList: action.payload.data.failType,
      weedoutChannelTypeList: action.payload.data.channelType,
    }),
  // 职位状态
  [actionTypes.POST_STATUS_GET_REQUEST_SUCCESS]:
    (state, action) => ({
      ...state,
      postStatusList: getPostStatusList(action.payload, action.meta.previousAction.meta.all),
    }),
    // 需求部门列表
  [actionTypes.NEED_DEPT_LIST_GET_REQUEST_SUCCESS]: (state, action) => ({...state, needDepartList: getNeedDepartList(action.payload.data)}),
}, defaultState);


export default statisticsReducer;
